import { render, staticRenderFns } from "./HeaderImage.vue?vue&type=template&id=61e41e34&"
import script from "./HeaderImage.vue?vue&type=script&lang=js&"
export * from "./HeaderImage.vue?vue&type=script&lang=js&"
import style0 from "./HeaderImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HeaderImage.vue"
export default component.exports